import { clearEmeraldModals } from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { showNotificationDialog } from '../components/ewic-modals/show-notification-modal';
import { InterpolationArguments } from 'react-i18next';

export const showNotification = async (
  title: string,
  message: string,
  type?: EmeraldDialogTypes,
  onApprove?: () => void,
  subMessageArgs?: InterpolationArguments,
  dialogTestIdPrefix?: string,
): Promise<void> => {
  return new Promise<void>(resolve => {
    const modalProps = {
      onApprove:
        onApprove ||
        (() => {
          clearEmeraldModals();
          resolve();
        }),
      message: title,
      subMessage: message,
      subMessageArgs,
      type,
      dialogTestIdPrefix,
    };
    showNotificationDialog(modalProps);
  });
};
